import axios from "axios";
import {
  getRefreshToken,
  setAccessToken,
  setUserSession,
  removeUserSession,
} from "../Utils/Common";

const userLogin = async (email, password) => {
  console.log(
    "Login Url--",
    process.env.REACT_APP_API_URL + "/api/users/login"
  );

  return axios
    .post(
      process.env.REACT_APP_API_URL + "/api/users/login",
      {
        email: email,
        password: password,
      },
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    )
    .then(async (response) => {
      console.log(response);
      console.log("Response--", response.data);
      return await getUserData(response.data, email);
    })
    .catch((error) => {
      // return error.response.data.message.toString;
      console.log(error?.response?.data?.error);
      if (error?.response?.status === 403 || error?.response?.status === 400) {
        if (
          error?.response?.data?.error ===
          "Access Denied - No roles assigned to this user."
        ) {
          return "You don't have access to this application.Contact your administrator.";
        }
        return "Invalid credentials.";
      } else {
        return `Something went wrong...`;
      }
    });

  // return apiResponse;
};

const userRegistration = async (values) => {
  return axios
    .post(
      process.env.REACT_APP_API_URL + "/api/users/register",
      {
        firstName: values.firstName,
        lastName: values.lastName,
        email: values.email,
        password: values.password,
        phone: values.phone,
        userType: values.type,
      },
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    )
    .then(async (response) => {
      console.log(response);
      console.log("Response--", response.data);
      return "done";
    })
    .catch((error) => {
      // return error.response.data.message.toString;
      console.log(error);
      return "Something went wrong...";
    });

  // return apiResponse;
};

const getUserData = async (token_data, email) => {
  console.log("Access" + token_data.access_token);
  return axios
    .get(process.env.REACT_APP_API_URL + "/api/users/find/email/" + email, {
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + token_data.access_token,
      },
    })
    .then((response) => {
      console.log(response);
      console.log("Response user--", response.data);
      setUserSession(token_data, response.data);
      return "done";
    })
    .catch((error) => {
      return "Something went wrong...";
    });
};

const RefreshToken = async () => {
  let refresh_token = getRefreshToken();
  return axios
    .get(process.env.REACT_APP_API_URL + "/api/users/token/refresh", {
      headers: {
        Authorization: "Bearer " + refresh_token,
      },
    })
    .then((response) => {
      console.log(response);
      console.log("Response user--", response.data);
      setAccessToken(response.data);
      return "done";
    })
    .catch((error) => {
      if (error.response) {
        if (error.response.status === 403) {
          const errorMessage = error.response.data.error_message;
          console.log("Token expired:", errorMessage);
          return "Token expired";
        } else {
          console.log("Server error:", error.response.data);
          return "Server error";
        }
      }
    });
};

//reset password
const resetPasswordEmailSending = async (email) => {
  return axios
    .get(process.env.REACT_APP_API_URL + "/api/users/forgotpassword/" + email, {
      headers: {
        "Content-Type": "application/json",
      },
    })
    .then((response) => {
      console.log(response);
      console.log("Response all--", response.data);
      return "success";
    })
    .catch((error) => {
      // return "Something went wrong...";
      console.log("send OTP email " + error);
      return "Something went wrong...";
    });
};

//OTP validation
const validateOTP = async (email, token) => {
  return axios
    .post(
      process.env.REACT_APP_API_URL + "/api/users/otp-validate",
      {
        email: email,
        token: token,
      },
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    )
    .then((response) => {
      console.log(response);
      console.log("Response all--", response.data);
      return "success";
    })
    .catch((error) => {
      // return "Something went wrong...";
      console.log("send OTP email " + error);
      return "Something went wrong...";
    });
};

//update password
const updatePassword = async (values) => {
  return axios
    .post(process.env.REACT_APP_API_URL + "/api/users/reset-password", values, {
      headers: {
        "Content-Type": "application/json",
      },
    })
    .then((response) => {
      console.log(response);
      console.log("Response all--", response.data);
      return "success";
    })
    .catch((error) => {
      // return "Something went wrong...";
      console.log("send OTP email " + error);
      return "Something went wrong...";
    });
};

export {
  userLogin,
  RefreshToken,
  userRegistration,
  resetPasswordEmailSending,
  validateOTP,
  updatePassword,
};
